// eslint-disable-next-line wix-custom-rules/wixstores-file-names
import {
  NameInLineItemWithLiterals,
  SuggestedFixWithLiterals,
  LineItem,
  NameInLineItem,
  SuggestedFix as SuggestedFixV2,
} from '@wix/auto_sdk_ecom_cart-v-2';
import {
  ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix,
  ComWixEcommerceValidationsSpiV1TargetNameInLineItem,
  ViolationLineItemTargetFragment,
} from '../../../../gql/graphql';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';

export class ViolationLineItemTargetModel {
  public name?: ViolationLineItemTargetName;
  public id?: string;
  public suggestedFix?: SuggestedFix;

  constructor(params: ViolationLineItemTargetModel) {
    this.name = params.name;
    this.id = params.id;
    this.suggestedFix = params.suggestedFix;
  }

  public static fromCheckoutV1(lineItemTarget?: ViolationLineItemTargetFragment | null) {
    if (!lineItemTarget) {
      return undefined;
    }

    return new ViolationLineItemTargetModel({
      name: lineItemTarget?.name
        ? toViolationLineItemTargetNameV1(lineItemTarget.name)
        : /* istanbul ignore next */ undefined,
      id: lineItemTarget?.id ?? /* istanbul ignore next */ undefined,
      suggestedFix: lineItemTarget?.suggestedFix ? toSuggestedFixV1(lineItemTarget.suggestedFix) : undefined,
    });
  }

  /* istanbul ignore next */
  public static fromCartV2(lineItemTarget?: LineItem) {
    if (!lineItemTarget) {
      return undefined;
    }
    return new ViolationLineItemTargetModel({
      name: lineItemTarget?.name
        ? toViolationLineItemTargetNameV2(lineItemTarget.name)
        : /* istanbul ignore next */ undefined,
      id: mapNullToUndefined(lineItemTarget?._id),
      suggestedFix: lineItemTarget?.suggestedFix ? toSuggestedFixV2(lineItemTarget.suggestedFix) : undefined,
    });
  }
}

export enum SuggestedFix {
  removeLineItem = 'REMOVE_LINE_ITEM',
  unknownSuggestedFix = 'UNKNOWN_SUGGESTED_FIX',
}

export enum ViolationLineItemTargetName {
  lineItemDefault = 'LINE_ITEM_DEFAULT',
}

const toViolationLineItemTargetNameV1 = (otherTargetName: ComWixEcommerceValidationsSpiV1TargetNameInLineItem) => {
  // eslint-disable-next-line sonarjs/no-small-switch
  switch (otherTargetName) {
    case ComWixEcommerceValidationsSpiV1TargetNameInLineItem.LINE_ITEM_DEFAULT:
      return ViolationLineItemTargetName.lineItemDefault;
    /* istanbul ignore next */ default:
      return undefined;
  }
};

const toViolationLineItemTargetNameV2 = (lineItemTargetName: NameInLineItemWithLiterals) => {
  const map: Record<NameInLineItem, ViolationLineItemTargetName> = {
    [NameInLineItem.LINE_ITEM_DEFAULT]: ViolationLineItemTargetName.lineItemDefault,
  };

  return map[lineItemTargetName];
};

const toSuggestedFixV1 = (suggestedFix: string) => {
  // eslint-disable-next-line sonarjs/no-small-switch
  switch (suggestedFix) {
    case ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix.REMOVE_LINE_ITEM:
      return SuggestedFix.removeLineItem;
    /* istanbul ignore next */ default:
      return undefined;
  }
};

const toSuggestedFixV2 = (suggestedFix: SuggestedFixWithLiterals) => {
  const map: Record<SuggestedFixV2, SuggestedFix> = {
    [SuggestedFixV2.REMOVE_LINE_ITEM]: SuggestedFix.removeLineItem,
    [SuggestedFixV2.UNKNOWN_SUGGESTED_FIX]: SuggestedFix.unknownSuggestedFix,
  };

  return map[suggestedFix];
};
